// extracted by mini-css-extract-plugin
export default {"wrapper":"input-skeleton-loader-module--wrapper--3c055","skeleton":"input-skeleton-loader-module--skeleton--4a84e"};